<template>
  <market-card class="market-gallery">
    <image-slider :images="images" />
  </market-card>
</template>

<script>
  import ImageSlider from '@base/components/ImageSlider.vue'
  import MarketCard from '@base/components/market/MarketCard.vue'

  export default {
    name: 'MarketGalleryCard',

    components: {
      ImageSlider,
      MarketCard,
    },

    props: {
      images: {
        type: Array,
        required: true,
      },
    },
  }
</script>

<style scoped>
  .market-gallery {
    padding: 0.75rem;
  }

  .market-gallery ::v-deep .carousel,
  .market-gallery ::v-deep .carousel-item {
    background: var(--ui-surface) !important;
  }

  .market-gallery ::v-deep .carousel {
    border-radius: 8px;
  }
</style>
